import React, { Component } from 'react';

import { Helmet } from 'react-helmet';

import moment from 'moment';
export default class RichCard extends Component {
	render() {
		let { job } = this.props;
		if (!job.address) {
			job.address = {
				street_number: '',
				route: '',
				locality: '',
				administrative_area_level_1: '',
				postal_code: '',
				country: ''
			};
		}
		const streetAddress = `${job.address.street_number} ${job.address.route}`;
		return (
			<Helmet>
				{
					<script type="application/ld+json">{`
            {
              "@context" : "http://schema.org/",
              "@type" : "JobPosting",
              "title" : "${job.title}",
              "description" : "<p>${job.about}</p>",
              "identifier": {
                "@type": "PropertyValue",
                "name": "${job.company}",
                "value": "${job.glassdoorId}"
              },
              "datePosted" : "${moment(job.created).toISOString()}",
              "hiringOrganization" : {
                "@type" : "Organization",
                "name" : "${job.company}",
                "sameAs" : "${job.companyURI}",
                "logo" : "${
									job.logo && job.logo.downloadURLs && job.logo.downloadURLs[0]
										? job.logo.downloadURLs[0]
										: null
								}"
              },
              "jobLocation" : {
                "@type" : "Place",
                "address" : {
                  "@type" : "PostalAddress",
                  "streetAddress" : "${streetAddress}",
                  "addressLocality" : "${job.address.locality}",
                  "addressRegion" : "${
										job.address.administrative_area_level_1
									}",
                  "postalCode" : "${job.address.postal_code}",
                  "addressCountry": "${job.address.country}"
                }
              }
            }
          `}</script>
				}
			</Helmet>
		);
	}
}

// COULD BE ADDED AFTER //
// (type="JobPosting" schema) validThrough:'...',
// (type="JobPosting" schema) employmentType:'...',
// <Generic type="baseSalary" jsonldtype="MonetaryAmount" >
//   <Generic type="value" jsonldtype="QuantitativeValue" schema={{value:'..', unitText:'...'}}/>
// </Generic>

// "@context" : "http://schema.org/",
//   "@type" : "JobPosting",
//   "title" : "Fitter and Turner",
//   "description" : "<p>Widget assembly role for pressing wheel assemblies.</p>
//     <p><strong>Educational Requirements:</strong> Completed level 2 ISTA
//     Machinist Apprenticeship.</p>
//     <p><strong>Required Experience:</strong> At
//     least 3 years in a machinist role.</p>",
//   "identifier": {
//     "@type": "PropertyValue",
//     "name": "MagsRUs Wheel Company",
//     "value": "1234567"
//   },
//   "datePosted" : "2017-01-18",
//   "validThrough" : "2017-03-18T00:00",
//   "employmentType" : "CONTRACTOR",

//   "hiringOrganization" : {
//     "@type" : "Organization",
//     "name" : "MagsRUs Wheel Company",
//     "sameAs" : "http://www.magsruswheelcompany.com",
//     "logo" : "http://www.example.com/images/logo.png"
//   },
//   "jobLocation" : {
//     "@type" : "Place",
//     "address" : {
//       "@type" : "PostalAddress",
//       "streetAddress" : "555 Clancy St",
//       "addressLocality" : "Detroit",
//       "addressRegion" : "MI",
//       "postalCode" : "48201",
//       "addressCountry": "US"
//     }
//   },
//   "baseSalary": {
//     "@type": "MonetaryAmount",
//     "currency": "USD",
//     "value": {
//       "@type": "QuantitativeValue",
//       "value": 40.00,
//       "unitText": "HOUR"
//     }
//   }

// 1) @type
//
// Set the @type to "JobPosting". For example:
//
// "@type": "JobPosting"
// baseSalary
// MonetaryAmount, Recommended
//
// The actual base salary for the job, as provided by the employer (not an estimate).
//
// Note: Only employers should provide baseSalary. If you're a third party job site, you can provide a salary estimate using the Occupation type.
// For the unitText of QuantitativeValue, use one of the following case-sensitive values:
//
// "HOUR"
// "DAY"
// "WEEK"
// "MONTH"
// "YEAR"
// For example:
//
// "baseSalary" : {
//   "@type": "MonetaryAmount",
//   "currency": "USD",
//   "value": {
//     "@type": "QuantitativeValue",
//     "value": 40.00,
//     "unitText": "HOUR"
//   }
// }
// To specify a salary range, define a minValue and a maxValue, rather than a single value. For example:
//
// "baseSalary" : {
//   "@type": "MonetaryAmount",
//   "currency": "USD",
//   "value": {
//     "@type": "QuantitativeValue",
//     "minValue": 40.00,
//     "maxValue": 50.00,
//     "unitText": "HOUR"
//   }
// }
// datePosted
// Date, Required
//
// The original date that employer posted the job in ISO 8601 format. For example, "2017-01-24" or "2017-01-24T19:33:17+00:00".
//
// "datePosted": "2016-02-18"
// description
// Text, Required
//
// The full description of the job in HTML format.
//
// The description should be a complete representation of the job, including job responsibilities, qualifications, skills, working hours, education requirements, and experience requirements. The description can't be the same as the title.
//
// Additional guidelines:
//
// You must format the description in HTML.
// At minimum, add paragraph breaks using <br>, <p>, or \n.
// Valid tags include <p>, <ul>, <li>, and headings <h1> through <h5>.
// You can also use character-level formatting tags such as <strong> and <em>.
// employmentType
// Text, Recommended
//
// Type of employment. For example:
//
// "employmentType" : "CONTRACTOR"
// Choose one or more of the following case-sensitive values:
//
// "FULL_TIME"
// "PART_TIME"
// "CONTRACTOR"
// "TEMPORARY"
// "INTERN"
// "VOLUNTEER"
// "PER_DIEM"
// "OTHER"
// You can include more than one employmentType property. For example:
//
// "employmentType" : ["FULL_TIME", "CONTRACTOR"]
// hiringOrganization
// Organization, Required
//
// The organization offering the job position. This should be the name of the company (for example, “Starbucks, Inc”), and not the specific location that is hiring (for example, “Starbucks on Main Street”). For example:
//
// "hiringOrganization" : {
//     "@type" : "Organization",
//     "name" : "MagsRUs Wheel Company",
//     "sameAs" : "http://www.magsruswheelcompany.com"
//   }
// Logos on third-party job sites
//
// If you have a third-party job site, you can provide a different logo for a given organization than the image shown in the organization's Knowledge Graph card. To request a different logo for a hiring organization, add the logo property to the hiringOrganizaion array. Make sure that you follow the logo image guidelines and Company logo guidelines. For example:
//
// "hiringOrganization" : {
//     "@type" : "Organization",
//     "name" : "MagsRUs Wheel Company",
//     "sameAs" : "http://www.magsruswheelcompany.com"
//     "logo" : "http://www.example.com/images/logo.png"
//   }
// identifier
// PropertyValue, Recommended
//
// The hiring organization's unique identifier for the job.
//
// For example:
//
// "identifier": {
//     "@type": "PropertyValue",
//     "name": "MagsRUs Wheel Company",
//     "value": "1234567"
// }
// jobLocation
// Place, Required
//
// The geographic location(s) where the employee will primarily work, not the location where the job was posted. Include as many fields as possible. The more properties you provide, the higher quality the job posting is to our users. For example:
//
// "jobLocation" : {
//   "@type": "Place",
//   "address": {
//     "@type": "PostalAddress",
//     "streetAddress": "555 Clancy St",
//     "addressLocality": "Detroit",
//     "addressRegion": "MI",
//     "postalCode": "48201",
//     "addressCountry": "US"
//   }
// }
// If the job has multiple locations, add multiple jobLocation properties in an array. Google will choose the best location to display based on the job seeker's query.
//
// For jobs in which the employee works remotely 100% of the time and therefore works from home, add the additionalProperty field with value TELECOMMUTE. For example:
//
// "jobLocation" : {
//   "@type": "Place",
//   "address" : {
//     "@type" : "PostalAddress" ,
//     "streetAddress" : "555 Clancy St" ,
//     "addressLocality" : "Detroit" ,
//     "addressRegion" : "MI" ,
//     "postalCode" : "48201" ,
//     "addressCountry" : "US"
//     },
//   "additionalProperty" : {
//       "@type" : "PropertyValue",
//       "value" : "TELECOMMUTE"
//     }
//   }
// title
// Text, Required
//
// The title of the job (not the title of the posting). For example, "Software Engineer" or "Barista". For example:
//
// "title" : "Software Engineer"
// Best practices:
//
// This field should be the title of the job only.
// Don't include job codes, addresses, dates, salaries, or company names in the title field.
// Not recommended: Apply now for IT job -FRENCH speaker in Bucharest
//
// Recommended: Market Specialist, French speaker
//
// Provide concise, readable titles.
// Don't overuse special characters such as "!" and "*". Abusing special characters might cause your markup to be considered as Spammy Structured Markup. Numbers and characters such as "/" and "-" are acceptable.
// Not recommended: *** WAREHOUSE HIRING NOW!! ON A BUS ROUTE!! ***
//
// Recommended: Shipping and Receiving Warehouse Associate
//
// Don't use name instead of title. The properties title and name aren't interchangeable.
// If you're a third party job site, don't attempt to modify the job title to follow the guidelines above, as it can make the title unreadable. Instead, provide the title as you received it from the employer.
// validThrough
// DateTime, Required
//
// Note: This is required for job postings that have an expiration date.
// The date when the job posting will expire in ISO 8601 format. For example, "2017-02-24" or "2017-02-24T19:33:17+00:00". For example:
//
// "validThrough" : "2017-03-18T00:00"
// If a job posting never expires, or you do not know when the job will expire, do not include this property. If the job is filled before the expiration date occurs, remove the job posting.

// https://developers.google.com/search/docs/data-types/job-posting
// https://search.google.com/structured-data/testing-tool



// WEBPACK FOOTER //
// ./src/components/RichCard.js